import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "UpdateCompaniesModal large",
    title: "Редактирование компаний",
    loading: _ctx.state.is_loading,
    onConfirm: _ctx.updateCompanies,
    onCancel: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        class: "mt-2",
        placeholder: "Компания",
        loading: _ctx.data_state.companies.is_loading,
        failed: _ctx.data_state.companies.is_failed,
        "error-text": "При получении списка компаний произошла ошибка",
        options: _ctx.data_state.companies.list,
        value: _ctx.state.companyIds,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.companyIds) = $event)),
        "infinite-scroll": "",
        "can-deselect": "",
        multiselect: "",
        "search-without-refresh": "",
        onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
        onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
        onSearch: _ctx.searchCompanies,
        onOptionBySearch: _ctx.unshiftFindedCompany
      }, null, 8, ["loading", "failed", "options", "value", "onSearch", "onOptionBySearch"])
    ]),
    _: 1
  }, 8, ["loading", "onConfirm", "onCancel"]))
}